<template>
  <v-container ma-0 pa-0 fluid style="height:100%;" class="pt-sans">
      <sub-tabs nomeSessao="Agendamento" :tabs="tabs">
      <v-layout row wrap>
        <v-flex offset-xs1 xs5 offset-md1 md5>
          <v-btn
          round
          large
          class="btn-green no-transform"
          dark
          v-if="showNewBtn"
          @click.native.stop="newSchedule"
          >
            <span class="pr-1">
              <v-icon dark>add_circle_outline</v-icon>
            </span>
            Novo Agendamento
          </v-btn>
        </v-flex>
        <v-flex xs5 md5>
          <v-text-field xs12 sm6 md3
          label="Pesquisar agendamentos"
          v-model="search"
          class="searchInput"
          append-icon="search"
          ></v-text-field>
        </v-flex>
      </v-layout>
      </sub-tabs>
      <schedule-modal></schedule-modal>
      <orders-list></orders-list>
  </v-container>
</template>

<script>
import subTabs from '@/components/painel/SubTabs'
import schedulesModal from './ScheduleModal/'
import ordersList from './OrdersList'
export default {
  name: 'PAtendimento',
  components: {
    'sub-tabs': subTabs,
    'schedule-modal': schedulesModal,
    'orders-list': ordersList
  },
  data () {
    return {
      tabs: [
        {
          nome: 'Agendados',
          url: 'Agendados'
        },
        {
          nome: 'Pendentes',
          url: 'Pendentes'
        },
        {
          nome: 'Realizados',
          url: 'Realizados'
        },
        {
          nome: 'Cancelados',
          url: 'Cancelados'
        }
      ]
    }
  },
  computed: {
    showNewBtn () {
      return this.$store.state.route.path.split('/')[3] === 'Agendados'
    },
    search: {
      get () {
        return this.$store.getters.searchSchedule
      },
      set (value) {
        this.$store.commit('updateSearchSchedule', value)
      }
    }
  },
  methods: {
    newSchedule () {
      this.$store.commit('newSchedule', '')
    }
  },
  beforeRouteLeave (to, from, next) {
    this.$store.commit('toggleScheduleDetailsModal', false)
    next()
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?11e512da